export const MainNavLinks = [
    { title: 'Map', path: '/' },
    { title: 'Stations', path: '/stations' },
    { title: 'Parameters', path: '/parameters' },
    { title: 'Parameter Definitions', path: '/parameter-definitions' },
];
